var bighouse = bighouse || {};

bighouse.rangeSlider = (function () {
    var lastCall = 0;
    var isResetting = false;

    function init() {
        initializeSliders('.js-partyRangeSlider', 'partysizemin', 'partysizemax');
        initializeSliders('.js-bedroomsRangeSlider', 'bedroomsquantitymin', 'bedroomsquantitymax');
    }

    function initializeSliders(sliderSelector, minInputId, maxInputId) {
        $(sliderSelector).each(function () {
            let startMin = parseInt($('#' + minInputId).val(), 10);
            let startMax = parseInt($('#' + maxInputId).val(), 10);
            let rangeMin = parseInt($(this).attr('data-min'), 10);
            let rangeMax = parseInt($(this).attr('data-max'), 10);

            initializeSlider(this, startMin, startMax, rangeMin, rangeMax, minInputId, maxInputId);
        });
    }

    function initializeSlider(slider, startMin, startMax, rangeMin, rangeMax, minInputId, maxInputId) {
        noUiSlider.create(slider, {
            start: [startMin, startMax],
            connect: true,
            range: {
                'min': rangeMin,
                'max': rangeMax
            },
            step: 1
        });

        slider.noUiSlider.on('update', function (values, handle) {
            updateSliderValues(values, handle, minInputId, maxInputId);
        });

        slider.noUiSlider.on('set', function () {
            if (lastCall + 200 < Date.now() && !isResetting) {
                lastCall = Date.now();
                bighouse.searchFilters.updateFilters();
            }
        });
    }

    function updateSliderValues(values, handle, minInputId, maxInputId) {
        let value = parseInt(values[handle], 10);
        if (handle) {
            updateDOMValue(maxInputId, value);
        } else {
            updateDOMValue(minInputId, value);
        }
    }

    function updateDOMValue(elementId, value) {
        let element = document.getElementById(elementId);
        element.value = value;
        element.setAttribute('value', value); // so the DOM updates properly
    }

    function resetSlider(sliderSelector, minInputId, maxInputId) {
        isResetting = true;

        const rangeMin = $(sliderSelector).attr('data-min');
        const rangeMax = $(sliderSelector).attr('data-max');
        const slider = $(sliderSelector)[0];
        slider.noUiSlider.set([rangeMin, rangeMax]);

        isResetting = false;
        bighouse.searchFilters.updateFilters();
    }

    function resetPartySize() {
        resetSlider('.js-partyRangeSlider', 'partysizemin', 'partysizemax');
    }

    function resetBedroomsQuantity() {
        resetSlider('.js-bedroomsRangeSlider', 'bedroomsquantitymin', 'bedroomsquantitymax');
    }

    function activeFilterSlider(sliderSelector, minInputId, maxInputId, min, max) {
        var slider = $(sliderSelector)[0];
        $(sliderSelector).attr('data-min', min);
        $(sliderSelector).attr('data-max', max);

        slider.noUiSlider.updateOptions({
            range: {
                'min': min,
                'max': max
            }
        });
    }

    function activeFilterPartySize(min, max) {
        activeFilterSlider('.js-partyRangeSlider', 'partysizemin', 'partysizemax', min, max);
    }

    function activeFilterBedroomsQuantity(min, max) {
        activeFilterSlider('.js-bedroomsRangeSlider', 'bedroomsquantitymin', 'bedroomsquantitymax', min, max);
    }

    return {
        init: init,
        resetPartySize: resetPartySize,
        resetBedroomsQuantity: resetBedroomsQuantity,
        activeFilterPartySize: activeFilterPartySize,
        activeFilterBedroomsQuantity: activeFilterBedroomsQuantity
    };
})();
